/// <reference lib="dom" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { normalizeUrl } from '@sisense/sdk-common';
import { BaseAuthenticator } from './base-authenticator.js';
import { appendHeaders } from './helpers.js';
import { errorInterceptor } from './interceptors.js';
import { TranslatableError } from './translation/translatable-error.js';
export class WatAuthenticator extends BaseAuthenticator {
    constructor(url, wat) {
        super('wat');
        this.url = `${normalizeUrl(url)}api/v1/wat/sessionToken`;
        this.body = `{"webAccessToken": "${wat}"}`;
    }
    authenticate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._tried) {
                return this._result;
            }
            this._tried = true;
            try {
                this._authenticating = true;
                const response = yield fetch(this.url, {
                    method: 'POST',
                    headers: {
                        accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: this.body,
                }).catch(errorInterceptor);
                if (response.ok) {
                    const responseJson = yield response.json();
                    this._initialiser = responseJson.initialiser;
                    this._webSessionToken = responseJson.webSessionToken;
                    this._resolve(true);
                }
            }
            catch (e) {
                // rather than returning empty catch block
                // throw an error to be caught by Sisense context provider
                throw new TranslatableError('errors.tokenAuthFailed');
            }
            finally {
                this._resolve(false);
                this._authenticating = false;
            }
            return this._result;
        });
    }
    applyHeaders(headers) {
        if (!!this._webSessionToken && !!this._initialiser) {
            const authHeader = this._webSessionToken;
            const initialiserHeader = this._initialiser;
            appendHeaders(headers, { Authorization: authHeader, Initialiser: initialiserHeader });
        }
    }
}
/**
 * Checks if an authenticator is a WatAuthenticator.
 *
 * @param authenticator - the authenticator to check
 * @internal
 */
export function isWatAuthenticator(authenticator) {
    return authenticator.type === 'wat';
}
//# sourceMappingURL=wat-authenticator.js.map